import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldCheck, Settings2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useConsent } from "@/lib/consent";
import { CookiePreferencesDialog } from "./CookiePreferencesDialog";

export function CookieBanner() {
  const { t } = useTranslation();
  const { needsDecision, acceptAll, rejectOptional, openManager, managerOpen } =
    useConsent();

  if (!needsDecision && !managerOpen) {
    return <CookiePreferencesDialog />;
  }

  return (
    <>
      {needsDecision && (
        <div
          role="dialog"
          aria-modal="false"
          aria-label={t("consent.banner.ariaLabel", "Aviso de cookies")}
          className="fixed inset-x-3 bottom-3 z-[60] md:inset-x-auto md:right-6 md:bottom-6 md:max-w-2xl pb-safe"
        >
          <div className="card-premium glass-surface-strong glass-border rounded-2xl p-5 md:p-6 shadow-[0_24px_60px_-20px_hsl(var(--primary)/0.35)] animate-in slide-in-from-bottom-4 fade-in duration-500">
            <div className="flex items-start gap-3">
              <div className="rounded-xl bg-primary/10 p-2 shrink-0">
                <ShieldCheck className="h-5 w-5 text-primary" aria-hidden="true" />
              </div>
              <div className="min-w-0 space-y-1">
                <h2 className="text-sm font-semibold text-foreground">
                  {t("consent.banner.title", "Sua privacidade é prioridade")}
                </h2>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  {t(
                    "consent.banner.body",
                    "Usamos cookies essenciais para o funcionamento da plataforma e, com seu consentimento, cookies opcionais para melhorar sua experiência. Você pode aceitar, rejeitar ou personalizar a qualquer momento.",
                  )}{" "}
                  <Link
                    to="/cookie-policy"
                    className="underline underline-offset-2 hover:text-primary transition-colors"
                  >
                    {t("consent.banner.policyLink", "Ler Política de Cookies")}
                  </Link>
                </p>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-2">
              <Button
                onClick={() => void acceptAll()}
                size="lg"
                className="w-full"
              >
                {t("consent.banner.acceptAll", "Aceitar todos")}
              </Button>
              <Button
                onClick={() => void rejectOptional()}
                size="lg"
                variant="outline"
                className="w-full"
              >
                {t("consent.banner.rejectOptional", "Rejeitar não essenciais")}
              </Button>
              <Button
                onClick={openManager}
                size="lg"
                variant="ghost"
                className="w-full"
              >
                <Settings2 className="mr-2 h-4 w-4" aria-hidden="true" />
                {t("consent.banner.manage", "Gerenciar preferências")}
              </Button>
            </div>
          </div>
        </div>
      )}
      <CookiePreferencesDialog />
    </>
  );
}
